import React, { useState } from 'react';
import DatePickerAccessible from 'helpers/reduxFormMaterialUiNext/DatePickerAccessible';
import FlatButton from 'material-ui/FlatButton';
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import { colors } from 'helpers/ColorHelper';

const RentersInsuranceList = ({ insuranceDetails, deleteDocument, editDocument }) => {
  const [toggleDateEditors, setToggleDateEditors] = useState([false]);
  const [assetIds, setAssetIds] = useState(['']);
  const [expiryDates, setExpiryDates] = useState([new Date()]);

  const handleDelete = assetId => {
    return deleteDocument(assetId);
  };

  const editExpiryDate = (date, index) => {
    const newExpiryDates = [...expiryDates];
    newExpiryDates[index] = date;
    setExpiryDates(newExpiryDates);
  };

  const handleSubmit = (e, index) => {
    e.preventDefault();
    const assetId = assetIds[index];
    const expiryDate = expiryDates[index];
    const newToggleDateEditors = [...toggleDateEditors];
    editDocument(assetId, expiryDate);
    newToggleDateEditors.fill(false);
    setToggleDateEditors(newToggleDateEditors);
  };

  const toggleDateEditor = (assetId, index) => {
    const newToggleDateEditors = [...toggleDateEditors];
    const newAssetIds = [...assetIds];
    newToggleDateEditors[index] = !newToggleDateEditors[index];
    newAssetIds[index] = assetId;
    setToggleDateEditors(newToggleDateEditors);
    setAssetIds(newAssetIds);
  };

  const rentersInsuranceList = insuranceDetails.map((insurance, index) => {
    const expiryDateStatus = insurance.document_expiry_status;
    let statusColor = colors.BLACK;
    if (expiryDateStatus === ('Expired' || 'Expiré')) {
      statusColor = colors.RED;
    } else if (expiryDateStatus === ('Expiring Soon' || 'Expire bientôt')) {
      statusColor = colors.YELLOW;
    }

    return (
      <div style={{ marginBottom: '20px', minHeight: '200px' }}>
        <div className="row" style={{ marginBottom: '4px' }}>
          <div className="row">
            <div className="col-xs-8" style={{ padding: '0px 5px' }}>
              <h4>{insurance.document_name}</h4>
              <p
                style={{
                  fontSize: '14px',
                  marginBottom: '1px',
                  color: statusColor,
                }}
              >
                {`${getTranslatedString(
                  'tenantPortal.rentersInsuranceList.validUntil'
                )} ${insurance.document_expiry_date}`}
              </p>
              {statusColor !== colors.BLACK ? (
                <p
                  style={{
                    fontSize: '14px',
                    marginBottom: '1px',
                    color: statusColor,
                  }}
                >
                  {expiryDateStatus}
                </p>
              ) : null}
            </div>
            <div className="col-xs-4">
              <div className="row" style={{ marginTop: '25px' }}>
                <div
                  className="col-xs-6"
                  style={{ textAlign: 'right', padding: '0px 5px' }}
                  onClick={() => toggleDateEditor(insurance.document_asset_id, index)}
                >
                  <EditOutlinedIcon style={{ color: AccentColor() }} />
                </div>
                <div
                  className="col-xs-6"
                  style={{ textAlign: 'right', padding: '0px 5px' }}
                  onClick={() => handleDelete(insurance.document_asset_id)}
                >
                  <DeleteForeverOutlinedIcon style={{ color: AccentColor() }} />
                </div>
              </div>
            </div>
          </div>
        </div>
        {toggleDateEditors[index] && (
          <form
            onSubmit={e => handleSubmit(e, index)}
            className="row"
            style={{ marginBottom: '10px' }}
          >
            <div className="col-sm-6" style={{ padding: '0px' }}>
              <DatePickerAccessible
                index={index}
                id={`key-${assetIds[index]}`}
                name="expiry_date"
                input={{
                  onChange: editExpiryDate,
                }}
                meta={{
                  touched: true,
                  error: null,
                }}
                label={getTranslatedString('expiryDate')}
                style={{ position: 'relative' }}
              />
            </div>
            <div className="col-sm-6" style={{ marginTop: '4px' }}>
              <FlatButton
                variant="raised"
                type="submit"
                style={{
                  height: '40px',
                  color: AccentColor(),
                  backgroundColor: 'white',
                }}
              >
                {getTranslatedString('landlordPortal.viewRentersInsuranceEditExpiry')}
              </FlatButton>
            </div>
          </form>
        )}
        <a
          style={{ padding: '0px 5px' }}
          href={`${insurance.document_url}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {getTranslatedString('tenantPortal.rentersInsuranceList.view')}
        </a>
      </div>
    );
  });

  return <div>{rentersInsuranceList}</div>;
};

export default RentersInsuranceList;
